export const SIZE = {
  small: 'small',
  middle: 'middle',
  large: 'large'
} as const
